import PostStatusSelect from "./post-status-select";



const PostFormItems = {
    Status: PostStatusSelect,
};

export default PostFormItems;